// let { REACT_APP_API_URL } = process.env;
import { localStore } from "helpers";
import { connect } from "react-redux";
import {
  apiUrl,
  apiUrlPublic,
  reportUrl,
  externalApi,
  customCDR,
} from "helpers/dotenv";
import axios from "axios";
import store from "store";
import consts from "consts";

const { LOGIN_TOKEN_KEY, LOGIN_REFRESH_TOKEN_KEY } = consts;

let REACT_APP_API_URL;
let tAPI = localStore.getItem("REACT_APP_API_URL");
if (
  tAPI &&
  typeof tAPI !== "undefined" &&
  tAPI !== "undefined" &&
  tAPI !== ""
) {
  REACT_APP_API_URL = tAPI;
}

let { CUSTOMER_ID } = process.env;
let tCustomerId = localStore.getItem("USER_ID");
if (
  tCustomerId &&
  typeof tCustomerId !== "undefined" &&
  tCustomerId !== "undefined" &&
  tCustomerId !== ""
) {
  CUSTOMER_ID = tCustomerId;
}

var instance = null;
class APIManager {
  constructor(tData) {
    if (instance) {
      return instance;
    }
    this.token = localStore.getItem("token");
    this.tenantId = ``;
    this.tURL = "";
    this.tDownloadUrl = "";
    // this.tURL = `${this.selectedOrganization.region.protocol}://${this.selectedOrganization.region.endpoint}/v1/`;
    // this.tDownloadUrl = `${this.selectedOrganization.region.protocol}://${this.selectedOrganization.region.endpoint}`;
    this.tURLPublic = apiUrlPublic;
    instance = this;
  }
  updateUrl(url, tenantId) {
    this.tURL = `${url}v1/`;
    this.tDownloadUrl = `${url}`;
    this.tenantId = tenantId;
  }
  resetUrl() {
    this.tURL = "";
  }
  downloadUrl(fileName) {
    return `${this.tDownloadUrl}/${fileName}`;
  }
  getRegionUrl() {
    return this.tURL;
  }
  removeByAttr(arr, attr, value) {
    var i = arr.length;
    while (i--) {
      if (
        arr[i] &&
        arr[i].hasOwnProperty(attr) &&
        arguments.length > 2 &&
        arr[i][attr] === value
      ) {
        arr.splice(i, 1);
      }
    }
    return arr;
  }

  async sendPostAPI(route, data, sCb, fCb, type, extraHeaders, method) {
    let url = this.tURL;
    var that = this;

    if (type && type === "summaryReport") {
      url = reportUrl;
    } else if (type && type === "customCDR") {
      url = customCDR;
    }
    const state = store.getState();
    const localstorageslice = state.localstorageslice;

    const RedixToken = localstorageslice ? localstorageslice.token : null;
    let header = {
      Authorization: `Bearer ${localStore.getItem("token")}`,
      "X-TENANT-ID": localStore.getItem("selected-tenant"),
      "Content-Type": "application/json",
    };
    if (extraHeaders) {
      header = { ...header, ...extraHeaders };
    }

    if (type === "public") {
      delete header["X-TENANT-ID"];
    }

    const token = localStore.getItem("erxesLoginToken")
      ? localStore.getItem("erxesLoginToken")
      : RedixToken;
    let cData = undefined;
    try {
      cData = JSON.stringify(data);
    } catch (e) {
      console.log(e);
    }
    let apiPath = url;
    if (type) {
      if (type == "public" || type == "public_auth") {
        apiPath = this.tURLPublic;
      } else if (type == "direct") {
        apiPath = "";
      } else if (type == "region") {
        apiPath = this.tURL;
      }
    }
    await fetch(`${apiPath}${route}`, {
      method: method || "POST",
      headers: header,
      body: cData,
    })
      .then(async (response) => {
        console.log(`response:`, response);
        if (response.status === 200 || response.status === 201) {
          return response.json();
        } else if (response.status === 401) {
          // remove tokens

          window.location.href = "/sign-in";
        } else if (response.status === 403) {
          // this.clearStorage();
          window.location.href = "/not-found";
        } else {
          let tBody = await response.json();
          fCb(response.status, tBody);
        }
      })
      .then(function(apiResponsData) {
        if (apiResponsData) {
          sCb(apiResponsData, data);
        }
      })
      .catch((e) => {
        console.log(e);
        fCb(e);
      });
  }

  sendGetAPI(route, sCb, fCb, type = "private") {
    var that = this;
    try {
      fetch(
        `${type && type == "public" ? this.tURLPublic : this.tURL}${route}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStore.getItem("token")}`,
            "X-TENANT-ID": localStore.getItem("selected-tenant"),
            "Content-Type": "application/json",
          },
          // body: JSON.stringify(data)
        }
      )
        .then(async (response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.clearStorage();
            window.location.href = "/sign-in";
          } else if (response.status === 403) {
            // this.clearStorage();
            window.location.href = "/not-found";
          } else {
            let tBody = await response.json();
            fCb(response.status, tBody);
          }
        })
        .then(function(data) {
          sCb(data);
        })
        .catch((e) => {
          console.log(e);
          fCb(e);
        });
    } catch (e) {
      console.log(e);
      fCb(e);
    }
  }
  getHeader(type, extraHeaders) {
    let header = {
      Authorization: `Bearer ${localStore.getItem("token")}`,
      "X-TENANT-ID": localStore.getItem("selected-tenant"),
      "Content-Type": type || "application/json",
    };
    if (extraHeaders) {
      header = { ...header, ...extraHeaders };
    }
    return header;
  }
  sendPostForm(
    route,
    formData,
    sCb,
    fCb,
    extraHeaders,
    progressFn,
    method = "POST"
  ) {
    // debugger;
    let headers = this.getHeader("multipart/form-data", extraHeaders);
    axios({
      method: method,
      url: `${this.tURL}${route}`,
      data: formData,
      headers: headers,
      onUploadProgress: progressFn,
    })
      .then(function(response) {
        console.log(`response:`, response);
        if (response.status === 200 || response.status === 201) {
          return response.data;
        } else if (response.status === 401) {
          this.clearStorage();
          window.location.href = "/sign-in";
        } else if (response.status === 403) {
          // this.clearStorage();
          window.location.href = "/not-found";
        } else {
          let tBody = response.data;
          console.log("apiResponse", response.data);
          fCb(response.status, tBody);
        }
      })
      .then(function(data) {
        if (data) {
          sCb(data);
        }
      })
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          fCb(error.response.status, error.response.data);
        } else {
          // Something happened in setting up the request that triggered an Error
          fCb(0, { message: "no response" });
        }
      });
  }
  clearStorage() {
    localStorage.removeItem(LOGIN_TOKEN_KEY);
    localStorage.removeItem(LOGIN_REFRESH_TOKEN_KEY);
    localStorage.removeItem("REACT_APP_API_SUBSCRIPTION_URL");
    localStorage.removeItem("REACT_APP_API_URL");
    localStorage.removeItem("REACT_FS_SERVER_HOST");
    localStorage.removeItem("USER_ID");
    // localStore.removeItem('selected-tenant');
    localStore.removeItem("token");
    localStore.removeItem("user");
  }
  downloadObjectAsJson(url) {
    const parsedUrl = new URL(url);
    if (!parsedUrl || !parsedUrl.pathname) {
      console.warn("Url pathname not found.", url, parsedUrl);
      return;
    }
    const pathname = parsedUrl.pathname;
    const parts = pathname.split("/");
    if (parts.length == 0) {
      console.warn("Url is not proper.", parts);
      return;
    }
    const exportName = parts[parts.length - 1];
    fetch(url)
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        var dataStr =
          "data:text/json;charset=utf-8," +
          encodeURIComponent(JSON.stringify(data));
        var downloadAnchorNode = document.createElement("a");
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", exportName);
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
      })
      .catch(function(err) {
        console.warn("Something went wrong.", err);
      });
  }
}
const mapStateToProps = (state) => ({
  user: state.user,
  menu: state.user.menu,
  isLogin: state.user.isLogin,
  currentUser: state.user.user,
  localstorageslice: state.localstorageslice,
});

const mapDispatchToProps = {
  // toggleIsDialerOpen,
  // setUser,
  // setMenu,
  // setIsLogin,
  // setToken
};

// export default connect(mapStateToProps, mapDispatchToProps)(APIManager);
// module.exports = APIManager;

export default APIManager;



// WEBPACK FOOTER //
// src/modules/common/apiManager.js